import {Model} from 'vue-mc';
import Vue from "vue";
import http from "../httpMiddleware/http";

Model.prototype.$http = http;
export default class availabilityModel extends Model {

    defaults() {
        return {}
    }

    options() {
        return {
            methods: {
                save: 'POST',
                fetch: 'GET',
                contact: 'GET'
            }
        }
    }

    routes() {
        return {
            save: 'interpreter/availability/phone',
            fetch: 'interpreter/availability/phone',
            contact: 'interpreter/contact'
        }
    }

    getInterpreterContactList(data) {
        let headers = {
            Bearer: localStorage.getItem('jwt')
        };
        let method = this.getOption('methods.contact');
        let route = Vue.prototype.$interpretersApiUrl + '/' + this.getRoute('contact');
        let params = this.getRouteParameters();
        let url = this.getURL(route, params);
        return this.getRequest({headers, method, url, data}).send();
    }
}
